import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { handleAd } from '@ifeng-fe/ui_pc_ad';
import { Event } from '@ifeng-fe/ui_base';

class TopicSlide extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        slideAd: PropTypes.object,
    };

    state = {
        data: this.props.content.data,
    };

    event = new Event();

    async componentDidMount() {
        try {
            const { slideAd } = this.props;

            const callback = await handleAd(slideAd);

            callback(slideAd.data, this.event, this.insert);
        } catch (e) {
            console.error(e);
        }

        try {
            this.event.trigger('init');
        } catch (e) {
            console.error(e);
        }
    }

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach((item) => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach((item) => {
                if (item === 4) {
                    const ref = React.createRef();
                    const ref1 = React.createRef();

                    refs.push({ index: item, ref, ref1 });

                    infoData.splice(item, 1, { type: 'ad', ref, ref1 });
                } else {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                }
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        if (ref.ref1) {
                            dom[ref.index] = [ref.ref.current, ref.ref1.current];
                        } else {
                            dom[ref.index] = ref.ref.current;
                        }
                    }

                    try {
                        adFn(dom);
                    } catch (e) {
                        console.error(e);

                        this.setState({
                            data,
                        });
                    }
                },
            );
        }

        return;
    };

    sliderTmpl = (item, isClone) => {
        return item.type === 'ad' ? (
            <div className={styles.slide_box} key="ad_key" ref={isClone ? item.ref1 : item.ref} />
        ) : (
            <div className={styles.slide_box}>
                <a href={item.url} target="_blank">
                    <img src={item.thumbnails?.[0]?.url || ''} />
                </a>
                <p>
                    <a href={item.url} target="_blank">
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    render() {
        const { data } = this.state;

        const config = {
            arrows: 'hover',
            direction: 'forward',
            axis: 'horizonta',
            sliderTmpl: this.sliderTmpl,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        return (
            <div className={styles.topic_slide} data-title="焦点图">
                <Slides content={data} config={config} />
            </div>
        );
    }
}

export default errorBoundary(TopicSlide);
